import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { LoadingService } from '../loading/loading.service';
import { TelemetryService } from '../telemetry/telemetry.service';

@Injectable()
export class AppErrorhandler implements ErrorHandler {
  constructor(
    protected httpClient: HttpClient,
    private loadingService: LoadingService,
    private telemetryService: TelemetryService,
  ) { }

  handleError(err: unknown): void {
    const normalizedErr = (err && typeof err === 'object' && 'originalError' in err)
      ? (err as { originalError?: unknown }).originalError || err
      : err;
    this.telemetryService.captureError(normalizedErr);
    this.loadingService.stopLoading();
    if (!environment.production) {
      console.log('syntax err:', normalizedErr);
    } else {
      const message =
        (normalizedErr && typeof normalizedErr === 'object' && 'error' in normalizedErr
          && (normalizedErr as { error?: { message?: string } }).error?.message)
          ? (normalizedErr as { error?: { message?: string } }).error.message
          : JSON.stringify(normalizedErr);
      if (this.shouldSendRemoteErrorLog()) {
        this.sendErrorLog(message);
      }
    }
  }

  sendErrorLog(message: string): void {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'text',
    };
    const data = {
      message,
      tag: 'web',
      url: window.location.href,
      userAgent: window.navigator.userAgent,
      userLang: window.navigator.language,
      level: 'error',
    };
    this.httpClient
      .put(environment.logtashUrl, data, {
        headers: options.headers,
        responseType: 'text',
      })
      .pipe(catchError(() => EMPTY))
      .subscribe((res) => {
        if (!environment.production) {
          console.log(res);
        }
      });
  }

  private shouldSendRemoteErrorLog(): boolean {
    return !!environment.logtashUrl;
  }
}
